import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  isFetchingCount: false,
  count: 0,
  keys: [],
  headers: [],
  data: [],
  error: null,
};

const dataFolderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_DATA_COUNT_REQUEST:
      return { ...state, isFetchingCount: true, error: null };

    case ActionTypes.FETCH_DATA_COUNT_SUCCESS:
      return {
        ...state,
        isFetchingCount: false,
        count: action.payload.count,
        keys: action.payload.keys || [],
      };

    case ActionTypes.FETCH_DATA_COUNT_FAILURE:
      return { ...state, isFetchingCount: false, error: action.payload };

    // --- folder data ---
    case ActionTypes.FETCH_DATA_FOLDER_REQUEST:
      return { ...state, isFetching: true, error: null };
    case ActionTypes.FETCH_DATA_FOLDER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        headers: action.payload.headers,
      };
    case ActionTypes.FETCH_DATA_FOLDER_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    case ActionTypes.FETCH_SEARCH_REQUEST:
      return { ...state, isFetching: true, error: null };
    case ActionTypes.FETCH_SEARCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        headers: action.payload.headers,
        count: action.payload.count,
      };
    case ActionTypes.FETCH_SEARCH_FAILURE:
      return { ...state, isFetching: false, error: action.payload };

    case "CLEAR_DATA_FOLDER":
      return {
        ...state,
        data: [],
        count: 0,
        keys: [],
      };

    default:
      return state;
  }
};

export default dataFolderReducer;
